<div fxLayout="row" fxLayoutWrap> 
	<div fxFlex="50" *ngFor="let type of container?.statisticalGroup.statisticalTypes">
		<pp-container-two-num-plus-minus-edit
			[type]="type"
			[container]="container"
			[statistics]="container?.statistics"
			(changed)="valueUpdated($event)">
		</pp-container-two-num-plus-minus-edit>
	</div>
</div>